export function getUserTicketForCheckIsLogin(){
  const userInfo = document.cookie.match(new RegExp("(^| )pa18_user_ticket=([^;]*)(;|$)"));
  if(userInfo){
    const userInfoVal = decodeURI(userInfo[2]);
    return userInfoVal !== "" ?true:false;
  }
  return false;
}
